import style from './GeneratedAssetList.module.css';
import { useState } from "react";
import GeneratedAssetView from "./GeneratedAssetView/GeneratedAssetView";

const GeneratedAssetList = ({url, title, list, assetKey, assetName}) => {
  const [audioPlaying, updateAudioPlaying] = useState(false);
  const [generatingPreview, updateGeneratingPreview] = useState(false);

  const count = list ? list.length : 0;
  const headerTitle = `${title} (${count})`;

  return (
    <div className={style.main}>
      <GeneratedAssetView heading={true} url={url} assetKey={assetKey} assetName={assetName}>{headerTitle}</GeneratedAssetView>
      <div className={style.list}>
        {
          list.map(item => {
            return (
              <GeneratedAssetView                 
                audioPlaying={audioPlaying}
                updateAudioPlaying={updateAudioPlaying}
                key={`gen-${item}`}
                url={url}
                assetKey={assetKey}
                generatingPreview={generatingPreview}
                updateGeneratingPreview={updateGeneratingPreview}
              >{item}</GeneratedAssetView>
            );
          })
        }
      </div>
    </div>
  );
}

export default GeneratedAssetList;